'use client';

import {
  useState,
} from 'react';

import {
  WAG_CONTENT_API_URL,
  HttpHeaderKey,
} from '../constants';
import { CookieKey } from '../constants/cookie-key';

import { getCookie } from '../utils/getCookie';
import { httpPost } from '../wag-react/common/api';

type Props = {
  token?: string;
  voteApiUrl: string;
};

export const postRateEndpoint = async (
  token,
  voteApiUrl,
) => {
  const data = await httpPost(
    voteApiUrl,
    undefined,
    {
      baseURL: WAG_CONTENT_API_URL,
      headers: {
        [HttpHeaderKey.XCsrfToken]: getCookie(CookieKey.CsrfToken),
        [HttpHeaderKey.Authorization]: `Token ${token}`,
      },
    },
  );
  return data;
};

export const usePostRateEndpoint = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async ({
    token,
    voteApiUrl,
  }: Props) => {
    setIsLoading(true);

    try {
      const response = await postRateEndpoint(token, voteApiUrl);
      setIsSuccess(true);
      setIsLoading(false);
      return response;
    } catch (_error) {
      setError(_error);
      setIsLoading(false);
      return _error;
    }
  };

  return {
    execute,
    isSuccess,
    isLoading,
    error,
  };
};
